<template>
    <div class="ml-3 mb-3 reply pl-3 pt-3 pr-3 pb-1">
        <p class="sm-text font-weight-normal"><em>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</em></p>

        <p class="sm-text text-right pr-4">{{replier}}<br>{{date}}</p>
    </div>
</template>

<script>
    export default {
        name: 'SupportTicketPreviousReply',

        methods: {
            action: function () {
                this.$emit('action');
            }
        },

        data() {
            return {
                replier: 'Tod Whitman',
                date: 'Jul 24, 2020, 4:01pm'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    .reply {
        background: #f4f4f4;
    }

    .sm-text {
        font-size: 12px;
    }
</style>
